import React, { memo } from 'react';
import { StyleSheet } from 'react-native';
import { AnchorRect } from '@/hooks/common/useAnchoredPosition';
import { IBulletinFormValues, BulletinFormFieldHandler } from '@/types/admin/bulletins';
import { PublishOptionsSectionBase } from '@/components/common/admin/shared/PublishOptionsSectionBase';

interface PublishOptionsSectionProps {
  formData: IBulletinFormValues;
  errors?: { publishTime?: string }; // Add errors prop
  onFieldChange: BulletinFormFieldHandler;
  onPublishTypeChange: (type: 'publishNow' | 'draft' | 'scheduled') => void;
  onPublishTimePress?: (anchor?: AnchorRect) => void;
}

export const PublishOptionsSection = memo<PublishOptionsSectionProps>(({ 
  formData,
  errors,
  onFieldChange,
  onPublishTypeChange,
  onPublishTimePress,
}) => {
  return (
    <PublishOptionsSectionBase
      title="When do you want to publish?"
      copy={{
        publishNow: { label: 'Publish Now', description: 'Bulletin will be visible to residents immediately' },
        draft: { label: 'Save as Draft', description: 'Bulletin will be saved but not visible to residents' },
        scheduled: { label: 'Schedule for Later', description: 'Choose when the bulletin becomes visible to residents' },
        scheduledFieldLabel: 'Publish Time *',
        scheduledPlaceholder: 'Select date and time',
      }}
      publishType={formData.publishType}
      publishTime={formData.publishTime || null}
      errorText={errors?.publishTime}
      onPublishTypeChange={onPublishTypeChange}
      onPublishTimePress={onPublishTimePress}
    />
  );
});

PublishOptionsSection.displayName = 'PublishOptionsSection';

const styles = StyleSheet.create({
});
